import { Injectable } from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot} from '@angular/router';
import {TokenManager} from './tokenManager';

// This Service class protects nav links / routes from unauthorized login, when used in the Router
// Ensures the presence of an access token before routing.
@Injectable()
export class LoginGuardService implements CanActivate {

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    if (TokenManager.token) {
      console.log('we have a token');
      return true;
    }
    console.log('no token');
    alert('Please login to continue');
    this._router.navigate(['/home']);
    return false;
  }

  constructor(private _router: Router) {
  }

}



// WEBPACK FOOTER //
// /home/jenkins-agent/workspace/ng-labportal-prod-build/src/app/shared/login-guard.service.ts